import React from 'react';
import { Icon } from '@frontend/icons';
import { styles } from '../../../styles';
import { Text } from '../../text';
import { ActionPressedChip } from '../atoms';

type ImageActionProps = Omit<React.ComponentProps<typeof ActionPressedChip>, 'children'>;

export const ImageAction = ({ compact = true, showBoxShadow = true, ...rest }: ImageActionProps) => {
  return (
    <ActionPressedChip {...rest} compact={compact} showBoxShadow={showBoxShadow}>
      <Text as='em' weight='bold' css={styles.flexCenter}>
        <Icon name='image-small' />
      </Text>
    </ActionPressedChip>
  );
};
